import { style } from '@vanilla-extract/css'

const textColor = '#3f434a'
const activeColor = '#ee7543'
const errorColor = '#f43e3b'

const button = style({
  outline: 'none',
  border: 'none',
  borderRadius: '32px',
  color: 'white',
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '1',
  letterSpacing: '0.075rem',
  height: '46px',
  boxSizing: 'border-box',
  padding: '8px 16px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  appearance: 'none',
  textDecoration: 'none',
})

const fluid = style({
  width: '100%',
  maxWidth: '480px',
})

const small = style({
  height: '32px',
  padding: '11px 16px',
  fontSize: '12px',
})

const primary = style({
  backgroundColor: activeColor,
})

const secondary = style({
  color: textColor,
  backgroundColor: '#eee',
})

const inverted = style({
  color: '#fff',
  backgroundColor: textColor,
})

const bordered = style({
  color: textColor,
  border: `1.5px solid ${textColor}`,
  backgroundColor: 'transparent',
})

const danger = style({
  backgroundColor: errorColor,
})

const inactive = style({
  backgroundColor: '#ccc',
  pointerEvents: 'none',
})

export const styles = {
  button,
  fluid,
  small,
  primary,
  secondary,
  inverted,
  bordered,
  danger,
  inactive,
}
